var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoEvents(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 132,
    viewBox: "0 0 180 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 273"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M50.7442 130H40.7326M33.5 130C16.034 130 1.875 117.065 1.875 101.109C1.875 85.1535 16.034 72.2187 33.5 72.2187C34.2427 72.2187 34.9795 72.2421 35.7094 72.2881C35.2022 69.6492 34.9375 66.9316 34.9375 64.1562C34.9375 38.9237 56.8196 18.4688 83.8125 18.4688C105.362 18.4688 123.654 31.5058 130.156 49.6027C131.696 49.4522 133.26 49.375 134.844 49.375C159.058 49.375 178.688 67.4235 178.688 89.6874C178.688 110.839 160.971 128.29 138.438 129.971V130H57.23H33.5Z",
    stroke: "#188AEC",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    d: "M84.5312 111.187C88.8978 111.187 92.4375 107.879 92.4375 103.797C92.4375 99.7151 88.8978 96.4062 84.5312 96.4062C80.1647 96.4062 76.625 99.7151 76.625 103.797C76.625 107.879 80.1647 111.187 84.5312 111.187Z",
    stroke: "#188AEC",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M62.25 88.3438L72.3125 80.9624L62.25 73.9355",
    stroke: "#188AEC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2",
    d: "M106.812 88.3438L96.75 80.9624L106.812 73.9355",
    stroke: "#188AEC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_2",
    d: "M98.1874 31.9062C107.544 34.221 114.932 41.061 117.508 49.769",
    stroke: "#188AEC",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_3",
    d: "M128.375 9.06249C130.757 9.06249 132.688 7.25764 132.688 5.03125C132.688 2.80485 130.757 1 128.375 1C125.993 1 124.062 2.80485 124.062 5.03125C124.062 7.25764 125.993 9.06249 128.375 9.06249Z",
    stroke: "#188AEC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_4",
    d: "M172.938 30.5625C175.319 30.5625 177.25 28.7576 177.25 26.5312C177.25 24.3049 175.319 22.5 172.938 22.5C170.556 22.5 168.625 24.3049 168.625 26.5312C168.625 28.7576 170.556 30.5625 172.938 30.5625Z",
    fill: "#188AEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line-5",
    d: "M139.526 19.4863L151.541 30.7177M151.724 19.4863L139.709 30.7177L151.724 19.4863Z",
    stroke: "#188AEC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line-4",
    d: "M3.89282 43.4575L12.5178 51.52M12.5178 43.4575L3.89282 51.52L12.5178 43.4575Z",
    stroke: "#188AEC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_5",
    d: "M23.4375 34.5937C25.8192 34.5937 27.75 32.7889 27.75 30.5625C27.75 28.3361 25.8192 26.5312 23.4375 26.5312C21.0558 26.5312 19.125 28.3361 19.125 30.5625C19.125 32.7889 21.0558 34.5937 23.4375 34.5937Z",
    fill: "#188AEC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoEvents);
export default __webpack_public_path__ + "static/media/noEvents.4a1bece482c3092b6e3ca60ac8599ac7.svg";
export { ForwardRef as ReactComponent };